import ApprovalFlowModal from './ApprovalFlowModal.container'

export default ApprovalFlowModal
